"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIxSun = 7000;
exports.zIxVenus = 6000;
exports.zIxMars = 5000;
exports.zIxMoon = 4000;
exports.zIxOrbit = 3000;
exports.zIxStratosphere = 2000;
exports.zIxEverest = 1000;
exports.zIxGround = 0;
exports.zIxSeaBottom = -1000;
exports.zIxHell = -2000;